import Immutable from 'immutable';
import _ from 'lodash';
import ImmutablePropTypes from 'react-immutable-proptypes';
import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import * as Alerts from '@bibliocommons/deprecated-base-alerts';

import FormattedHTMLMessage from 'app/components/shared/FormattedHTMLMessage';
import keyMirror from 'keymirror';

const STATUS_TYPES = keyMirror({
  Success: null,
  Failure: null,
  Neutral: null
});

class Generic extends React.PureComponent {
  constructor(props) {
    super(props);
    this.timeout = null;
  }

  componentDidMount() {
    this.scheduleMessageClearance();
  }

  componentDidUpdate(prevProps) {
    if (this.timeout && this.props.message !== prevProps.message) {
      clearTimeout(this.timeout);
      this.timeout = null;
      this.scheduleMessageClearance();
    }
  }

  componentWillUnmount() {
    if (this.timeout) {
      clearTimeout(this.timeout);
      this.timeout = null;
    }
  }

  scheduleMessageClearance() {
    const { clearMessages, duration, failureDuration } = this.props;
    if (duration) {
      const durationToUse = this.getAlertType() === STATUS_TYPES.Failure ? failureDuration : duration;
      this.timeout = setTimeout(() => {
        if (clearMessages) {
          clearMessages();
        }
        this.timeout = null;
      }, durationToUse);
    }
  }

  getDefaultMessage() {
    if (this.props.message.get('defaultMessage')) {
      return this.props.message.get('defaultMessage');
    }

    if (this.getAlertType() === STATUS_TYPES.Failure) {
      return this.props.intl.formatMessage({ id: 'errors.ServiceException' });
    }

    return undefined;
  }

  getAlertType() {
    const type = this.props.message.get('type');
    const alertType = _.last(type.split('_'));

    return _.capitalize(alertType);
  }

  render() {
    const { clearMessages, message, renderActionButton } = this.props;
    const extraValues = this.props.values || Immutable.Map();
    const Component = Alerts[`Alert${this.getAlertType()}`];

    if (!Component) {
      return null;
    }

    const MessageComponent = this.props.useFormattedMessage ? FormattedMessage : FormattedHTMLMessage;

    return (
      <Component handleDismiss={clearMessages}>
        <MessageComponent
          id={message.get('id')}
          values={extraValues.merge(message.get('values', Immutable.Map())).toJS()}
          defaultMessage={this.getDefaultMessage()}
        />
        {renderActionButton()}
      </Component>
    );
  }
}

Generic.propTypes = {
  message: ImmutablePropTypes.map.isRequired,
  values: ImmutablePropTypes.map,
  duration: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  clearMessages: PropTypes.func.isRequired,
  failureDuration: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
  useFormattedMessage: PropTypes.bool,
  renderActionButton: PropTypes.func
};

Generic.defaultProps = {
  duration: 20000,
  failureDuration: 20000,
  renderActionButton: () => null
};

export default injectIntl(Generic);
